<template>
  <div class="status-icon-wrapper">
    <i
      class="material-icons"
      :style="{ color: iconColor }"
      :title="tooltipText"
      aria-hidden="true"
    >
      {{ iconName }}
    </i>
  </div>
</template>

<script>
export default {
  name: 'StatusIndicator',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconName() {
      if (
        this.item.status.includes('!')
        || this.item.status.includes('должник')
        || this.item.status === 'Заключение не дано'
        || this.item.status === 'Справка'
      ) return 'close'; // красный крестик
      if (
        (this.item.conclusion.trim() === '' && !this.item.status.includes('Завершен'))
        || this.item.status === 'Ожидание результатов') return 'radio_button_checked'; // жёлтый кружок
      return 'check_circle'; // зелёная галочка
    },
    iconColor() {
      if (
        this.item.status.includes('!')
        || this.item.status.includes('должник')
        || this.item.status === 'Заключение не дано'
        || this.item.status === 'Справка'
      ) return '#e53935'; // красный
      if (
        (this.item.conclusion.trim() === '' && !this.item.status.includes('Завершен'))
        || this.item.status === 'Ожидание результатов') return '#fbc02d'; // жёлтый
      return '#43a047'; // зелёный
    },
    tooltipText() {
      return `Заключение: ${this.item.conclusion || '—'}\nОт: ${this.item.conclusion_date || '—'}\nГоден до: ${this.item.date_expire || '—'}`;
    },
  },
};
</script>

<style scoped>
.status-icon-wrapper {
  display: inline-flex;
  align-items: center;
  cursor: help;
}
.material-icons {
  font-size: 24px;
}
</style>
